import { PromiseCompletionSource, Viewable } from "scene-manager";
import { GameView } from "./views/GameView";
import { inject, injectable } from "@launchtray/tsyringe-async";
import { GameView3d } from "./views/GameView3d";
import { ICanvasScaler } from "../../../canvas/ICanvasScaler";
import { InjectableInterfaces } from "../../composition/InjectableInterfaces";
import { GameController } from "./controllers/GameController";
import { RenderCamera } from "../../three/RenderCamera";
import { CommonResourcesPackage } from "../../common/resources/CommonResourcesPackage";
import { PlayerModel } from "../../common/models/PlayerModel";
import { GameViewModel } from "./models/GameViewModel";
import { Renderer } from "pixi.js";
import { GameResourcesPackage } from "./resources/GameResourcesPackage";
import { AudioController } from "./components/AudioController";
import { GameModel } from "./models/GameModel";
import { LevelModel } from "../../common/models/LevelModel";
import { FontResourcesPackage } from "../../common/resources/FontResourcesPackage";
import { LocalizationModel } from "../../common/models/LocalizationModel";
import { SpineResourcesPackage } from "../../common/resources/SpineResourcesPackage";
import { SaveModel } from "../../common/models/SaveModel";
import { SettingsModel } from "../../common/models/SettingsModel";
import { BoostersConfiguration } from "../../common/models/BoostersConfiguration";
import { GameSceneOptions } from "./GameSceneOptions";

@injectable()
export class GameScene extends Viewable<void> {
    public constructor(
        commonResources: CommonResourcesPackage,
        gameResources: GameResourcesPackage,
        fontResources: FontResourcesPackage,
        spineResources: SpineResourcesPackage,
        localization: LocalizationModel,
        saveModel: SaveModel,
        playerModel: PlayerModel,
        boostersConfiguration: BoostersConfiguration,
        settingsModel: SettingsModel,
        levelModel: LevelModel,
        gameModel: GameModel,
        gameViewModel: GameViewModel,
        gameController: GameController,
        audioController: AudioController,
        @inject(InjectableInterfaces.GameSceneOptions)
        options: GameSceneOptions,
        @inject(InjectableInterfaces.ICanvasScaler)
        canvasScaler: ICanvasScaler,
        renderCamera: RenderCamera,
        renderer: Renderer
    ) {
        super();
        const pcs = new PromiseCompletionSource<void>();
        const gameView3d = new GameView3d(
            gameResources,
            fontResources,
            localization,
            gameModel,
            saveModel,
            playerModel,
            boostersConfiguration,
            levelModel,
            gameViewModel,
            gameController,
            audioController,
            renderCamera,
            renderer,
            options.initialHousesRotation,
            pcs
        );
        this.view3d = gameView3d;
        this.view = new GameView(
            commonResources,
            gameResources,
            spineResources,
            playerModel,
            settingsModel,
            localization,
            gameModel,
            gameViewModel,
            gameController,
            audioController,
            gameView3d,
            canvasScaler,
            pcs
        );
        pcs.result.then(
            () => {
                this.operationControls.complete();
            },
            (reason: unknown) => {
                this.operationControls.error(reason);
            }
        );
    }
}
